<template>
  <div :key="componentKey" :class="classPanelBuilder()" :data-fixed="fixedBanner()"
       :data-fixed-mobile="fixedBannerMobile()"
       :keyChange="keyChange" class="sitebuilder-element-panel"
       element="PanelComponent"
       v-on:click="focusElement($event)"
       @contextmenu.prevent="handler($event)">
    <div :id="id"
         ref="elem"
         :config-properties="JSON.stringify(internal_config)"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         class="panel panel-primary draggable container-fluid"
         element="PanelComponent"
         v-bind:style="{
          'border-radius': radius,
          height : height,
          minHeight : minHeight,
          borderWidth : borderWidth,
          borderStyle : borderStyle(),
          borderColor : borderColor(),
          'box-shadow': boxShadow,
          ...backgroundData
        }"
    >
      <div v-show="internal_config.video != '' && internal_config.videoInternal == false" class="panel-video-place"
           v-html="videoContent">
      </div>
      <div :config-properties="JSON.stringify(internal_config)" :keyChange="keyChange"
           class="panel-body container"
           v-bind:style="{
              minHeight : minHeight,
              ...internalBackgroundData
           }"
      >
        <div ref="defaultOptions" class="default-options">
          <span>{{ $t('ct-component-PanelComponent') }}</span>
          <img v-tooltip="{content:$t('ct-option-save'),  class: 'tooltip-custom'}"
               class="svg-icon"
               src="static/images/icons/salvar.svg"
               @click="saveElementDefault"/>
          <img v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
               class="svg-icon"
               src="static/images/icons/editar.svg"
               @click="handler($event)"/>
          <img v-tooltip="{content:$t('ct-option-clone'),  class: 'tooltip-custom'}"
               class="svg-icon  hide-mobile-action"
               src="static/images/icons/duplicar.svg"
               v-on:click="duplicatePanel"/>
          <img v-tooltip="{content:$t('ct-option-hide'),  class: 'tooltip-custom'}"
               class="svg-icon"
               src="static/images/icons/ocultar.svg"
               @click="togglePanel()"/>
          <div class="vr"></div>
          <img v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
               class="svg-icon danger  hide-mobile-action"
               src="static/images/icons/deletar.svg"
               v-on:click="deletePanel"/>
        </div>
        <div v-show="internal_config.video != '' && internal_config.videoInternal == true" class="panel-video-place"
             v-html="videoContent"></div>


        <div v-if="props.columns && device !== 'desktop'" class="row">
          <component :is="element.name" v-for="(element,index) in elements"
                     :id="element.id" :key="index" :childs="element.childs"
                     :class="`col-${12/props.columns_count}`" :config="element.config"
                     :device="device"
                     :height_start="index" :preview="preview" :style="`max-width: ${ 100 / props.columns_count }%`"
                     @setCallbackChangeDevice="setCallbackChangeDevice"></component>
        </div>
        <component :is="element.name" v-for="(element,index) in elements" v-else :id="element.id"
                   :key="index" :childs="element.childs"
                   :config="element.config"
                   :device="device" :height_start="index" :preview="preview"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>

        <div v-show="device == 'mobile'" class="panel-side-banner"></div>
      </div>
      <div v-show="internal_config.arrowActive" class="arrow-panel-down"
           v-bind:style="{width: widthArrow,left: leftArrow,'border-left': transparentArrowSide,'border-right': transparentArrowSide,'border-top': colorArrowSide}">
      </div>

      <separator-panel
          ref="separatorData"
          :data-hide-desktop="!this.internal_config.showDesktop"
          :data-hide-mobile="!this.internal_config.showMobile"></separator-panel>
      <resources ref="resourcesData"></resources>

      <delete-confirmation-modal ref="delete" @confirm="continueDelete"/>
    </div>

    <div
        :data-hide-desktop="!this.internal_config.showDesktop"
        :data-hide-mobile="!this.internal_config.showMobile"
        v-html="this.internal_config.separatorHtml"></div>
  </div>
</template>
<script>
var startY, startHeight;

import Model from './Model';
import Resources from './Resources.vue';
import {SweetModal} from 'sweet-modal-vue';
import SeparatorPanel from "./Separator";

export default {
  name: 'PanelElement',
  components: {
    SeparatorPanel,
    Model,
    Resources,
    SweetModal,
  },
  props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
  data() {
    return Model.data()
  },
  computed: {
    backgroundColor() {
      if (this.$globalStoreHelpers.isValidHex(this.internal_config.backgroundColor)) {
        this.internal_config.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.backgroundColor);
      }

      return this.internal_config.backgroundColor;
    },
    backgroundImage() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        if (this.internal_config.backgroundImage !== null)
        return 'url("' + this.internal_config.backgroundImage + '")';
      }

      const isGradient = /(linear-gradient)/i.test(this.internal_config.backgroundColor)
      return isGradient ? this.internal_config.backgroundColor : 'none';
    },
    backgroundPosition() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        return this.internal_config.backgroundPosition
      }
      return '';
    },
    backgroundOrigin() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        return this.internal_config.backgroundOrigin
      }
      return '';
    },
    backgroundRepeat() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        return this.internal_config.backgroundRepeat
      }
      return '';
    },
    backgroundSize() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        return this.internal_config.backgroundSize
      }
      return '';
    },
    backgroundAttachment() {
      if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
        return this.internal_config.backgroundAttachment
      }
      return '';
    },
    backgroundData() {
      return {
        backgroundColor: this.backgroundColor,
        backgroundImage: this.backgroundImage,
        backgroundSize: this.backgroundSize,
        backgroundPosition: this.backgroundPosition,
        backgroundOrigin: this.backgroundOrigin,
        backgroundRepeat: this.backgroundRepeat,
        backgroundAttachment: this.backgroundAttachment,
      }
    },
    internalBackgroundColor() {
      if (this.$globalStoreHelpers.isValidHex(this.internal_config.internalBackgroundColor)) {
        this.internal_config.internalBackgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.internalBackgroundColor);
      }

      return this.internal_config.internalBackgroundColor;
    },
    internalBackgroundImage() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return 'url("' + this.internal_config.internalBackgroundImage + '")';
      }
      const isGradient = /(linear-gradient)/i.test(this.internal_config.internalBackgroundColor)
      return isGradient ? this.internal_config.internalBackgroundColor : 'none';
    },
    internalBackgroundPosition() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return this.internal_config.internalBackgroundPosition
      }
      return '';
    },
    internalBackgroundOrigin() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return this.internal_config.internalBackgroundOrigin
      }
      return '';
    },
    internalBackgroundRepeat() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return this.internal_config.internalBackgroundRepeat
      }
      return '';
    },
    internalBackgroundSize() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return this.internal_config.internalBackgroundSize
      }
      return '';
    },
    internalBackgroundAttachment() {
      if (this.internal_config.internalBackgroundImage && this.internal_config.internalBackgroundImage !== 'none') {
        return this.internal_config.internalBackgroundAttachment
      }
      return '';
    },
    internalBackgroundData() {
      return {
        backgroundColor: this.internalBackgroundColor,
        backgroundImage: this.internalBackgroundImage,
        backgroundSize: this.internalBackgroundSize,
        backgroundPosition: this.internalBackgroundPosition,
        backgroundOrigin: this.internalBackgroundOrigin,
        backgroundRepeat: this.internalBackgroundRepeat,
        backgroundAttachment: this.internalBackgroundAttachment,
      }
    },
    widthArrow() {
      if (this.device == 'desktop') {
        return this.internal_config.arrowWidth + '%';
      } else {
        return this.internal_config.arrowWidthMobile + '%';
      }
    },
    leftArrow() {
      if (this.device == 'desktop') {
        let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidth / 2);
        return 'calc(50% - ' + arrowWidth + 'px)';
      } else {
        let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidthMobile / 2);
        return 'calc(50% - ' + arrowWidth + 'px)';
      }

    },
    transparentArrowSide() {
      if (this.device == 'desktop') {
        let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidth / 2);
        return arrowWidth + 'px solid transparent';
      } else {
        let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidthMobile / 2);
        return arrowWidth + 'px solid transparent';
      }

    },
    colorArrowSide() {
      return this.internal_config.arrowHeight + 'px solid ' + this.internal_config.arrowColor;
    },
    border() {
      return this.internal_config.border;
    },
    borderWidth() {
      return this.internal_config.borderWidth;
    },
    height() {
      return this.internal_config.height;
    },
    minHeight() {
      return this.internal_config.minHeight;
    },
    typeVideo() {
      try {
        if (this.internal_config.video != '') {
          return 'video/' + this.internal_config.video.split('.').pop();
        }
      } catch (e) {
        console.log(e);
        return '';
      }

      return '';
    },

    videoContent() {
      if (typeof this.internal_config.video != 'undefined' && this.internal_config.video != '') {

        let extension = 'video/' + this.internal_config.video.split('.').pop().toLowerCase();
        let autoplay = this.internal_config.autoplay == true ? 'autoplay ' : '';
        let loop = this.internal_config.loop == true ? 'loop ' : '';
        let muted = this.internal_config.muted == true ? 'muted ' : '';

        return '<video class="panel-video" ' + autoplay + '' + loop + '' + muted + ' id="myVideo"><source src="' + this.internal_config.video + '" type="' + extension + '"></video>'
      }
    },
    srcVideo() {
      try {
        if (this.internal_config.video != '') {
          return this.internal_config.video;
        }
      } catch (e) {
        console.log(e);
        return '';
      }

      return '';
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    // // bg-color bg-image position/bg-size bg-repeat bg-origin
    // background() {
    //   let bg = this.internal_config.backgroundColor;
    //
    //   if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
    //
    //     bg += ' url("' + this.internal_config.backgroundImage + '")';
    //     bg += ' ' + this.internal_config.backgroundPosition;
    //     bg += ' / ' + this.internal_config.backgroundSize;
    //     bg += ' ' + this.internal_config.backgroundRepeat;
    //     bg += ' ' + this.internal_config.backgroundOrigin;
    //     if (typeof this.internal_config.backgroundAttachment !== 'undefined')
    //       bg += ' ' + this.internal_config.backgroundAttachment;
    //   }
    //
    //   return bg;
    // },
    // internalBackground() {
    //   let bg = this.internal_config.internalBackgroundColor;
    //
    //   if (this.internal_config.internalBackgroundImage) {
    //
    //
    //     bg += ' url("' + this.internal_config.internalBackgroundImage + '")';
    //     bg += ' ' + this.internal_config.internalBackgroundPosition;
    //     bg += ' / ' + this.internal_config.internalBackgroundSize;
    //     bg += ' ' + this.internal_config.internalBackgroundRepeat;
    //     bg += ' ' + this.internal_config.internalBackgroundOrigin;
    //     if (typeof this.internal_config.internalBackgroundAttachment !== 'undefined')
    //       bg += ' ' + this.internal_config.internalBackgroundAttachment;
    //   }
    //
    //   return bg;
    // },
  },
  methods: {

    borderColor() {
      let [borderWidth, borderStyle, borderColor] = this.internal_config.border.split(' ');
      return borderColor;
    },
    borderStyle() {
      let [borderWidth, borderStyle, borderColor] = this.internal_config.border.split(' ');
      return borderStyle;
    },
    isPopup() {
      return window.location.href.indexOf('editor-layout-item/popup/') !== -1;
    },
    build(config) {

      let vm = this;

      if (typeof config.orderElementsConfig !== 'undefined' && config.orderElementsConfig) {
        try {
          vm.echoElements(config.data);
          let elements = [...this.elements.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0))]
          config.data = config.data.filter(data => data.name !== null && data.name);

          let arr1 = config.data.map(data => data.name !== null && data.name);
          let arr2 = elements.map(data => data.name !== null && data.name);

          if (_.difference(arr1, arr2).length === 0) {
            vm.echoElements(config.data);
          }
        } catch (e) {
          console.error(e);
        }
      }

      vm.internal_config = _.merge(vm.internal_config, config);

      if (typeof vm.internal_config.orderElementsConfig !== 'undefined') {
        delete vm.internal_config['orderElementsConfig']
      }
      vm.keyChange++;
      vm.$forceUpdate();
      vm.panelDividerEffect();
      vm.$eventHub.setValueElementConfig(vm.id, vm.internal_config);

      this.$root.$emit('updateAnchor', vm);
    },

    classPanelBuilder() {
      return (this.internal_config.hidePanel && this.internal_config.typeHidePanel === 'action') ? `show-hide-on-action panel-action-name-${this.internal_config.nameHidePanel.replaceAll(' ', '-')}` : '';
    },
    fixedBanner() {

      if (this.internal_config.fixed) {
        if (this.$props.preview) {

          var panels = document.querySelectorAll('.sitebuilder-element-panel');

          let firstEl = Array.from(panels)
              .find(node => node.querySelector('div.panel:not([data-hide-desktop=true])'));

          var panel = firstEl.querySelector('div.panel');

          return this.id === panel.id;
        }
      }

      return false;
    },
    fixedBannerMobile() {

      if (this.internal_config.fixedMobile) {
        if (this.$props.preview) {

          var panels = document.querySelectorAll('.sitebuilder-element-panel');

          let firstEl = Array.from(panels)
              .find(node => node.querySelector('div.panel:not([data-hide-mobile=true])'));

          var panel = firstEl.querySelector('div.panel');

          return this.id === panel.id;
        }
      }

      return false;
    },

    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },

    animation() {
      return false;
    },

    continueDelete() {

      this.$refs.delete.close();
      this.$parent.removePanel(this.$refs.elem.id);
    },

    duplicatePanel() {
      this.$parent.duplicatePanel(this.id);
    },

    deletePanel() {
      this.$refs.delete.open();
    },

    reorderPanel(idx) {
      // let id = this.id,
      //   sibling = idx === 1 ? document.getElementById(id).parentNode.nextSibling : document.getElementById(id).parentNode.previousSibling;

      // if (sibling.firstChild === null) {
      //   return true;
      // }

      // this.$parent.changeOrderPanel(id, sibling.firstChild.id)

    },
    togglePanel() {
      this.$root.$emit('toggleElement', this);
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    focusElement(event) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);
      this.initDragY(this.id);

      event.preventDefault();
    },
    echoElements(configArray) {
      let vm = this;

      vm.$nextTick(function () {

        let elements = this.$parent.changeOrderElementsWithArray(vm.id, configArray, vm.elements);
        // console.log(elements);
        vm.elements = {};


        //  vm.$parent.updateChilds();

        vm.$nextTick(function () {
          vm.elements = elements.childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          vm.$forceUpdate();
          vm.$parent.sort();
        })
      })
      // vm.$parent.sort();

    },
    //change order on html
    changeOrderPanel(elem, idx) {
      const id = elem.$el.id;
      const sibling = idx > 0 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

      if (!sibling) return true;

      const elements = this.$parent.changeOrderElements(this.id, id, sibling.id, idx).childs;

      this.elements = [];

      this.$nextTick(() => {
        elements
          .sort((a, b) => a.config.order_mobile - b.config.order_mobile)
          .forEach((item, i) => {
            item.config.order_mobile = i;
          });

        this.elements = elements;
      });
    },
    getMinHeight: function () {
      let height = 0;
      let elements = this.$el.getElementsByClassName('sitebuilder-element-container');
      [].forEach.call(elements, function (el) {

        if ((el.offsetHeight + el.offsetTop) > height) {
          height = el.offsetHeight + el.offsetTop;
        }
      });

      return height + 10;
    },
    handler: function (e) {
      this.$refs.resourcesData.setMinValuesData('height', this.getMinHeight());
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    saveElementDefault() {
      this.$root.$emit('saveElement', this);
    },
    panelDividerEffect() {
      this.internal_config.separatorHtml = '';
      if (this.internal_config.separatorActive) {
        let separatorColors = this.internal_config.separatorColors;
        if (this.internal_config.separatorEffect === 'waves-floating')
          this.internal_config.separatorHtml = this.$refs.separatorData.wavesSeparator(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['fourth'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3'],
              separatorColors['value4']
          );
        if (this.internal_config.separatorEffect === 'drip-up')
          this.internal_config.separatorHtml = this.$refs.separatorData.dripColors(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              'up',
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'drip-down')
          this.internal_config.separatorHtml = this.$refs.separatorData.dripColors(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              'down',
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'mid-arrow')
          this.internal_config.separatorHtml = this.$refs.separatorData.midArrow(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'waves-fixed')
          this.internal_config.separatorHtml = this.$refs.separatorData.wavesFixed(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'polygon')
          this.internal_config.separatorHtml = this.$refs.separatorData.polygonCraqued(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'polygon-up')
          this.internal_config.separatorHtml = this.$refs.separatorData.polygonUp(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'banner-lateral')
          this.internal_config.separatorHtml = this.$refs.separatorData.bannerLateral(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'drops')
          this.internal_config.separatorHtml = this.$refs.separatorData.drops(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2']
          );
        if (this.internal_config.separatorEffect === 'waves-lateral')
          this.internal_config.separatorHtml = this.$refs.separatorData.wavesLateral(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'zigzag')
          this.internal_config.separatorHtml = this.$refs.separatorData.zigzag(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'big-arrow')
          this.internal_config.separatorHtml = this.$refs.separatorData.bigArrow(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'clouds')
          this.internal_config.separatorHtml = this.$refs.separatorData.cloudsEffect(
              separatorColors['first'],
              separatorColors['custom'],
              separatorColors['value1']
          );
        if (this.internal_config.separatorEffect === 'curve')
          this.internal_config.separatorHtml = this.$refs.separatorData.curveEffect(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'arrow-reverse')
          this.internal_config.separatorHtml = this.$refs.separatorData.arrowReverse(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'pixels')
          this.internal_config.separatorHtml = this.$refs.separatorData.pixels(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
        if (this.internal_config.separatorEffect === 'big-round')
          this.internal_config.separatorHtml = this.$refs.separatorData.bigRound(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2']
          );
        if (this.internal_config.separatorEffect === 'breaker')
          this.internal_config.separatorHtml = this.$refs.separatorData.breaker(
              separatorColors['first'],
              separatorColors['second'],
              separatorColors['third'],
              separatorColors['custom'],
              separatorColors['value1'],
              separatorColors['value2'],
              separatorColors['value3']
          );
      }
    },

    /**** DRAG Y *****/
    initDragY(id) {
      this.currentElement = document.getElementById(id);
      document.querySelectorAll('.resizer').forEach(e => e.parentNode.removeChild(e));
      let resizer = document.createElement('div');
      resizer.className = 'resizer hide-mobile-action';
      this.currentElement.appendChild(resizer);
      resizer.addEventListener('mousedown', this.initDrag, false);
    },
    initDrag(e) {
      startY = e.clientY;
      startHeight = parseInt(document.defaultView.getComputedStyle(this.currentElement).height, 0);
      document.documentElement.addEventListener('mousemove', this.doDrag, false);
      document.documentElement.addEventListener('mouseup', this.stopDrag, false);
    },
    doDrag(e) {
      let newWHeight = startHeight + e.clientY - startY
      this.currentElement.style.height = newWHeight < parseInt(this.minHeight) ? this.minHeight : newWHeight + 'px';
    },
    stopDrag(e) {
      this.internal_config.height = this.currentElement.style.height;
      if (this.$refs.resourcesData)
        this.$refs.resourcesData.setHeight(this.currentElement.style.height);
      document.documentElement.removeEventListener('mousemove', this.doDrag, false);
      document.documentElement.removeEventListener('mouseup', this.stopDrag, false);
      $('.widget-focused').trigger('click')
    },
    sendNewChilds() {

      let vm = this;

      setTimeout(() => {
        vm.$eventPointer.changePointerState(true);
        vm.$eventPointer.logChilds(vm.id, vm.elements);
        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
        }, 500)
      }, 1000)
    },
    /**** END DRAG Y *****/
  },
  watch: {
    device: function () {
      if (this.internal_config.arrowActive) {
        let wid = this.internal_config.arrowWidth;
        this.internal_config.arrowWidth = 0;
        this.internal_config.arrowWidth = wid
      }
    },
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },
  created() {
    this.componentKey = '1';
    if (typeof this.config.borderWidth === 'undefined' && typeof this.$props.config.border !== 'undefined') {
      let [borderWidth] = this.$props.config.border.split(' ');
      this.$props.config.borderWidth = `${borderWidth} ${borderWidth} ${borderWidth} ${borderWidth}`;
    }
  },

  mounted() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);

    this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    if (this.internal_config.animation) {
      delete this.internal_config.animation
    }

    this.device = device;

    if (typeof id !== 'undefined') {
      this.id = id;
    }

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });

    if (objIds.includes(this.id)) {
      let newId = Date.now() + parseInt(Math.random() * 10000);
      this.id = newId;

      childs.forEach((el, index) => {
        try {
          childs[index].config.parent_id = newId;
        } catch (e) {
        }
      })

      this.$refs.elem.id = newId;
    }

    if (typeof childs !== 'undefined') {
      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
    } else {
      this.elements = [];
    }

    if (this.$props.preview) {

      let vm = this;
      setTimeout(function () {
        if (vm.internal_config.parallaxActive == true) {
          $(vm.$refs.elem).jarallax({
            type: vm.internal_config.parallaxEffect,
            speed: vm.internal_config.parallaxSpeed / 10,
            imgSize: vm.internal_config.backgroundSize,
            imgPosition: vm.internal_config.backgroundPosition,
            imgRepeat: vm.internal_config.backgroundRepeat,
          });
        }
      }, 1000);

      setTimeout(function () {
        try {

          let $siteBuilderPanel = $('.sitebuilder-element-panel');

          var panels = document.querySelectorAll('.sitebuilder-element-panel');

          var device = vm.device;

          let firstEl = Array.from(panels)
              .find(node => node && node.hasAttribute('data-fixed') && node.querySelector(`div.panel:not([data-hide-${device}=true])`));

          if (!firstEl)
            return;

          let firstID = firstEl.querySelector('div.panel');

          var firstPanelValid;
          var nextPanelValid;

          for (var i = 0; i < $siteBuilderPanel.length; i++) {

            var div = $siteBuilderPanel[i].querySelector('div.panel:not([data-hide-desktop=true])');

            if (div && div.id === firstID.id) {
              firstPanelValid = $siteBuilderPanel[i];
            } else if (div && !nextPanelValid) {
              nextPanelValid = $siteBuilderPanel[i];
            }
          }

          if (!nextPanelValid)
            return;

          if ($('[data-fixed="true"]').length > 0) {
            nextPanelValid.style.marginTop = firstPanelValid.getBoundingClientRect().height + 'px';
          } else {
            nextPanelValid.classList.add('remove-margin-top');
          }

          if ($('[data-fixed-mobile="true"]').length > 0) {
            nextPanelValid.style.marginTop = firstPanelValid.getBoundingClientRect().height + 'px';
          } else {
            nextPanelValid.classList.add('remove-margin-top-mobile')
          }
        } catch (e) {
          console.error('error fixed panel', e);
        }
      }, 2000);

    }

    this.panelDividerEffect();

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });
    this.$root.$on('setChildsObj', (id) => {
      if (this.id == id) {

        this.$eventPointer.logChilds(this.id, this.elements);

        let childsHub = this.$eventHub.getChilds(this.id);

        this.config.childs = childsHub;
        this.internal_config.childs = childsHub;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;

          this.$nextTick(() => {
            this.sendNewChilds();
            this.$root.$emit('activeSort');
            // this.$refs.resourcesData.setValuesData(this);
          });
        });
      }
    });

    this.$root.$on('setChildsUndoRedo', (id, childs) => {
      if (this.id == id) {
        this.$eventHub.setChilds(this.id, childs);

        this.config.childs = childs;
        this.internal_config.childs = childs;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;
        });
      }
    });

    if (this.isPopup()) {
      this.internal_config.hidePanel = false;
    }
    // this.$refs.resourcesData.setValuesData(this);

    this.$root.$emit('updateAnchor', this);
  }
}
</script>

<style>
.panel-video,
.panel-video-place {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  overflow: hidden;
  left: 0;
}

.resizer {
  width: 100%;
  height: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  cursor: ns-resize;
  outline: 1px solid #007bff !important;
  z-index: 90;
}

.resizer::after {
  position: absolute;
  content: close-quote;
  width: 10px;
  height: 10px;
  background: #007bff;
  left: 50%;
  top: -5px;
  border-radius: 50%;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.arrow-panel-down {
  position: absolute;
  z-index: 10;
}

.panel-side-banner {
  position: absolute;
  width: 10px;
  top: 0;
  left: -10px;
  height: 100%;
  border-radius: 5px 0 0 5px;
}

.panel {
  width: 100%;
}

.sitebuilder-element-panel,
.panel,
.panel-body {
  position: relative;
}

.resizable {
  /* overflow: hidden; */
  resize: both
}

.draggable {
  /* position: relative; */
  /* z-index: 100 */
}

.draggable-handler {
  cursor: pointer
}

.dragging {
  cursor: move;
  /* z-index: 200 !important */
}

.panel-body {
  height: 100%;
}

.v--modal-overlay[data-modal="my_modal_name"] {
  background: transparent;
}

.container {
  /*border: 1px dotted gray;*/
}

.container-fluid {
  /*border: 1px dotted gray;*/
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Panel/Panel.vue